const eventAdvertiseString = {
  VIEW: "view",
  COUNT_ALL_VIEW_ADVERTISES_IN_ALL_POSITIONS_IN_WEB_SITE_PUBLISHER: "count_all_view_advertises_in_all_positions_in_web_site_publisher",
};
const eventAdvertisePersian = {
  VIEW: "تعداد نمایش",
  COUNT_ALL_VIEW_ADVERTISES_IN_ALL_POSITIONS_IN_WEB_SITE_PUBLISHER: "تعداد نمایش",
};
export default { eventAdvertiseString, eventAdvertisePersian };
